<template>

    <loader v-if="!loaded"></loader>
    <div class="row" v-else>
        <div class="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
            <div
                v-if="edit === true && !contractCanBeEdited"
                class="box box-danger"
            >
                <div class="box-header">
                    <h2 class="box-title">Contract kan niet aangepast worden</h2>
                </div>
                <div class="box-body">
                    <p>Dit contract kan niet meer aangepast worden, omdat deze reeds geactiveerd is (geweest).</p>
                    <p>Voeg s.v.p. een nieuw contract toe om aanpassen door te voeren voor deze gebruiker.</p>
                </div>
            </div>

            <div v-else>
                <contracts-form
                    v-if="edit === true && contractCanBeEdited"
                    :user-data="JSON.stringify(this.getHrUser)"
                    :user-groups-data="JSON.stringify(this.user_groups)"
                    :contract-types="JSON.stringify(this.contracttypes)"
                    :function-groups="JSON.stringify(this.functiongroups)"
                    :post-uri="getPostUri"
                    :contract-data="JSON.stringify(this.contract)"
                    @contractSaveCompleted="onComplete"
                ></contracts-form>
                <contracts-form
                    v-else
                    :user-data="JSON.stringify(this.getHrUser)"
                    :user-groups-data="JSON.stringify(this.user_groups)"
                    :contract-types="JSON.stringify(this.contracttypes)"
                    :function-groups="JSON.stringify(this.functiongroups)"
                    :post-uri="getPostUri"
                    @contractSaveCompleted="onComplete"
                ></contracts-form>
            </div>
        </div>
    </div>

</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import Loader from "../../../../components/Common/Loader";
import ContractsForm from "../../../../components/HR/Contracts/Form";

export default {

    components: {
        Loader,
        ContractsForm,
    },

    computed: {
        ...mapGetters([
            'getHrUser',
            'getHrUserContracts',
        ]),

        contractCanBeEdited() {
            return this.contract &&
                (
                    this.contract.is_concept === true ||
                    this.contract.contractnumber === null
                );
        },

        getPostUri() {
            return this.edit === true ?
                this.route('api.v1.hr.users.contracts.edit', {id:this.getHrUser.uuid, contract_uuid:this.contract.uuid}) :
                this.route('api.v1.hr.users.contracts.add', {id:this.getHrUser.uuid});
        },

        hasUnsetContract() {
            return this.getHrUserContracts.filter(contract => {
                return contract.end === null &&
                    contract.duration === 'unset' &&
                    contract.is_concept !== true;
            }).length > 0;
        },
    },

    data() {
        return {
            edit:false,
            loaded:false,

            // Received from info call
            contract:{},
            contracttypes:{},
            functiongroups:[],
            user_groups:[],
        }
    },

    methods: {
        prepare(contract_uuid = null) {
            let params = {id: this.getHrUser.uuid};

            if (contract_uuid !== null) {
                params.contract_uuid = contract_uuid;
            }

            axios.get(this.route('api.v1.hr.users.contracts.info', params))
                .then(response => {
                    this.contracttypes = response.data.contracttypes;
                    this.functiongroups = response.data.functiongroups;
                    this.user_groups = response.data.user_groups;

                    if (response.data.contract) {
                        this.edit = true;
                        this.contract = response.data.contract;
                    }

                    this.loaded = true;
                });
        },

        onComplete() {
            this.$emit('updateContractdata');
        },
    },

    mounted(){
        if (this.$route.params.contract_uuid) {
            this.prepare(this.$route.params.contract_uuid);
        } else {
            this.prepare();
        }

    },

    name:'HrUsersContractsForm',

}

</script>
